import { render } from "./Column202410.vue?vue&type=template&id=c67b5baa&scoped=true"
import script from "./Column202410.vue?vue&type=script&lang=js"
export * from "./Column202410.vue?vue&type=script&lang=js"

import "./Column202410.vue?vue&type=style&index=0&id=c67b5baa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c67b5baa"

export default script